import {Order} from "../../../store/state/order.state";

export interface OrderHistory {
	changeSets: ChangeSet[];
}

export enum ChangeAuthor {
	CLIENT = 'CLIENT',
	APPLICATION_REVIEWER = 'APPLICATION_REVIEWER',
	CLIENT_SERVICE = 'CLIENT_SERVICE'
}

export interface ChangeSet {
	timestamp: Date;
	order: Order;
	author: ChangeAuthor;
	changes: Changes;
	isInsert: boolean;
	hideInHistoryView?: FeatureToHideInHistoryView[];
}

export enum FeatureToHideInHistoryView {
	PRICE_FACTOR_INDICATORS = 'PRICE_FACTOR_INDICATORS',
}

export interface Changes {
	company: CompanyChanges;
	contactPerson: ContactPersonChanges;
	certificateFilesChanged: boolean;
	reportFilesChanged: boolean;
	productChanges: { [key: string]: ProductChanges };
	billingInformationsChanges: BillingInformationsChanges;
}

export interface CompanyChanges {
	name: Change;
	street: Change;
	city: Change;
	zipCode: Change;
	state: Change;
	country: Change;
	taxId: Change;
	kvkNr: Change;
}

export interface ContactPersonChanges {
	firstName: Change;
	lastName: Change;
	jobTitle: Change;
	email: Change;
	phoneNumber: Change;
	salesperson: Change;
}

export interface ProductChanges {
	employees: Change;
	shifts: Change;
	companyDescription: Change;
	lastAuditEvent: Change;
	otherCB: Change;
	scopes: { [key: string]: ScopeChange };
	totalPrice: Change;
	priceAdjustments: PriceAdjustmentChange;
	priceFactors: { [key: string]: PriceFactorChange };
	additionalQuestions: AdditionalQuestionsChanges;
	catastrophicRisk: Change;
	estimateQuestions: { [questionId: string]: Change };
	effectiveDailyRate: Change;
	effectiveComplexityFactor: Change;
	effectiveAuditEffort: Change;
	effectiveBusinessComplexity: Change;
	effectiveItComplexity: Change;
	effectiveRisk: Change;
	scopeDescriptionNeedsNarrowing: Change;
	scopeDescription: Change;
	employeesWithinScope: Change;
	partTimeOrTempEmployeesIncluded: Change;
	employeesCountDescription: Change;
}

export interface PriceAdjustmentChange {
	dailyRate: Change;
	auditEffort: Change;
	businessComplexity: Change;
	itComplexity: Change;
}

export interface ScopeChange extends Change {
	changeType: 'ADDED' | 'REMOVED' | 'QUESTION_CHANGED';
	questionChanges: ScopeQuestionChange[];
}

export interface ScopeQuestionChange {
	questionType: string;
	change: Change;
}

export interface PriceFactorChange {
	answer: Change;
}

export interface AdditionalQuestionsChanges {
	desiredNextAuditDate: Change;
	outsourcedProcesses: Change;
	textQuestionChanges: { [key: string]: TextQuestionChange };
	binaryQuestionChanges: { [key: string]: BinaryQuestionChange };
	initialCertQuestionsChanges: InitialCertQuestionsChanges;
	transferQuestionsChanges: TransferQuestionsChanges;
}

export interface TextQuestionChange {
	description: Change;
}

export interface BinaryQuestionChange {
	answer: Change;
	description: Change;
}

export interface InitialCertQuestionsChanges {
	preAuditRequested: Change;
	desiredPreAuditDate: Change;
	desiredStage1AuditDate: Change;
}

export interface TransferQuestionsChanges {
	transferReason: Change;
	isCurrentCertificationBodyAccredited: Change;
	hasOpenNonConformities: Change;
	hasCorrectiveActionPlans: Change;
	numberOfMajorNonConformities: Change;
	numberOfMinorNonConformities: Change;
	lastAuditPerformedDate: Change;
	expirationDate: Change;
}

export interface BillingInformationsChanges {
	sameCompanyAndContactPersonAsProvided: Change;
	billingCompany: CompanyChanges;
	billingContactPersonChanges: ContactPersonChanges;
	isPurchaseNumberRequiredForPayment: Change;
	purchaseOrderNumber: Change;
	coverTravelExpenses: Change;
	additionalInformation: Change;
}

export interface Change {
	previousValue: any;
	currentValue: any;
}
